import { render, staticRenderFns } from "./SliceColumn.vue?vue&type=template&id=4c0bc65c&scoped=true&"
import script from "./SliceColumn.vue?vue&type=script&lang=js&"
export * from "./SliceColumn.vue?vue&type=script&lang=js&"
import style0 from "./SliceColumn.vue?vue&type=style&index=0&id=4c0bc65c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0bc65c",
  null
  
)

export default component.exports